"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");


























































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], droplist2: [], searchData: { id: '', deviceTypeCode: '', version: '', templateName: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, tableColumns: [{ prop: 'name', label: '固件名称', isShow: true }, { prop: 'templateName', label: '模板名称', isShow: true }, { prop: 'deviceTypeName', label: '设备类型', isShow: true }, { prop: 'firmwareType', label: '固件类型', formatter: _formatter.firmwareTypeFormatter, isShow: true }, { prop: 'version', label: '固件版本号', isShow: true }, { prop: 'enabled', label: '状态', formatter: _formatter.enabledFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', sortable: true, formatter: _formatter.dateFormatter, isShow: false }, { prop: 'updateTime', label: '更新时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'remark', label: '备注', isShow: false }], pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', deviceTypeId: '', enabled: '', filePath: '', firmwareType: '', deviceTypeName: '', name: '', version: '', remark: '', deviceTypecode: '', templateId: '' }, defaultData: { id: '', deviceTypeId: '', enabled: '', filePath: '', firmwareType: '', deviceTypeName: '', name: '', version: '', remark: '', deviceTypecode: '', templateId: '' }, rules: { deviceTypeId: [{ required: true, message: '请选择设备类别', trigger: 'blur' }], firmwareType: [{ required: true, message: '请选择设备类型', trigger: 'blur' }], name: [{ required: true, message: '请输入固件名称', trigger: 'blur' }], version: [{ required: true, message: '请输入固件版本号', trigger: 'blur' }], filePath: [{ required: true, message: '请输入固件存放地址', trigger: 'blur' }], remark: [{ required: true, message: '请输入备注', trigger: 'blur' }], templateId: [{ required: true, message: '请选择模板', trigger: 'blur' }], enabled: [{ required: true, message: '请选择是否启用', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.init();self.getdrop();self.getdrop2();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;
      self.getData('/api/faFirmwareInfo', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    resetFun: function resetFun() {// 重置
      this.searchData.templateName = '';
      this.searchData.deviceTypeCode = '';
      this.searchData.version = '';
      this.searchData.page = 1;
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    getdrop2: function getdrop2() {
      var self = this;
      self.getData('/api/faProgramTemplate/list', {}, function (res) {
        self.droplist2 = res;
      });
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faFirmwareInfo/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs.addForm.resetFields();
      // this.$refs['addForm'].resetFields()
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (self.addData.enabled == '0') {
        self.addData.enabled = 0;
      } else if (self.addData.enabled == '1') {
        self.addData.enabled = 1;
      }
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faFirmwareInfo', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      if (item.enabled === 0) {
        this.$message({
          message: '已经启用，不能再修改!',
          type: 'warning' });

        return;
      }
      console.log('修改', item);
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        deviceTypeId: item.deviceTypeId,
        filePath: item.filePath,
        firmwareType: item.firmwareType,
        deviceTypeName: item.deviceTypeName,
        name: item.name,
        version: item.version,
        enabled: item.enabled,
        remark: item.remark,
        deviceTypecode: item.deviceTypecode,
        templateId: item.templateId };

      if (item.firmwareType == '0') {
        self.addData.firmwareType = 'wifi模块';
      } else if (item.firmwareType == '1') {
        self.addData.firmwareType = '主板模块';
      }
      if (item.enabled == '0' || item.enabled == false) {
        self.addData.enabled = '禁用';
      } else if (item.enabled == '1' || item.enabled == true) {
        self.addData.enabled = '启用';
      }

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      if (self.addData.firmwareType == 'wifi模块') {
        self.addData.firmwareType = 0;
      } else if (self.addData.firmwareType == '主板模块') {
        self.addData.firmwareType = 1;
      }
      if (self.addData.enabled == '禁用') {
        self.addData.enabled = 0;
      } else if (self.addData.enabled == '启用') {
        self.addData.enabled = 1;
      }
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faFirmwareInfo/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            // self.onCencal()
            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    changeappTypeFun: function changeappTypeFun(val) {
      var self = this;
      if (val === 1) {
        self.addData.firmwareType = 1;
      }if (val === 0) {
        self.addData.firmwareType = 0;
      }
    },
    changeEnabledFun: function changeEnabledFun(val) {
      var self = this;
      if (val === 1 || val === true) {
        self.addData.enabled = 1;
      }if (val === 0 || val === false) {
        self.addData.enabled = 0;
      }
    },
    RecommendFun: function RecommendFun(item) {
      var self = this;
      console.log(item);
      self.postData('/api/faFirmwareInfo/recommend/' + item.id, {}, function (res) {
        self.$message({
          message: '推荐成功!',
          type: 'success' });

        self.onCencal();
        self.searchData.page = 1;
        self.init();
      });
    } } };exports.default = _default;